import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { HomeResponse } from './home.model';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  changes: string;

  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    this.loadChanges();
  }

  loadChanges() {
    this.homeService.getChanges()
      .pipe(map((res: HomeResponse) => {
        if (res.model) {
          this.changes = res.model;
        }
        if(res.error.message){
          this.changes = res.error.message;
        }
      }))
      .subscribe();
  }
}
